import { all } from 'redux-saga/effects'

import { extendReferralWatcherSaga } from './saga.extendReferral'
import {
  getForgetPasswordSagaWatcherSaga,
  getAccessCodeWatcherSaga,
} from './saga.forgetPassword'
import { memberDetailWatcherSaga } from './saga.memberDetail'
import { memberSearchWatcherSaga } from './saga.memberSearch'
import { getPlanDetailWatcherSaga } from './saga.planDetail'
import {
  getMedicalNeighborhoodWatcherSaga,
  getNeighborhoodProviderWatcherSaga,
} from './saga.practiceProfile'
import { practiceReportsWatcherSaga } from './saga.practiceReports'
import { providerDetailsWatcherSaga } from './saga.providerDetail'
import { referralManagementWatcherSaga } from './saga.referralManagement'
import {
  getSpecialtyListWatcherSaga,
  getAreaOfFocusWatcherSaga,
  getLocationWatcherSaga,
  findProviderWatcherSaga,
} from './saga.referralProvider'
import {
  selectedMemberDetailWatcherSaga,
  removeSelectedMemberDetailWatcherSaga,
  shufflingSelectedMemberDetailWatcherSaga,
} from './saga.selectedMember'
import {
  getSignInUserWatcherSaga,
  getUserWatcherSaga,
  ssoLoginWatcherSaga,
} from './saga.signInUser'
import { submitReferralProviderWatcherSaga } from './saga.submitReferralProvider'
import { getReferralMemberWatcherSaga } from './saga.getReferralMember'

export default function* root() {
  yield all([
    memberSearchWatcherSaga(),
    memberDetailWatcherSaga(),
    getSpecialtyListWatcherSaga(),
    getAreaOfFocusWatcherSaga(),
    getLocationWatcherSaga(),
    findProviderWatcherSaga(),
    referralManagementWatcherSaga(),
    extendReferralWatcherSaga(),
    selectedMemberDetailWatcherSaga(),
    removeSelectedMemberDetailWatcherSaga(),
    shufflingSelectedMemberDetailWatcherSaga(),
    submitReferralProviderWatcherSaga(),
    providerDetailsWatcherSaga(),
    getSignInUserWatcherSaga(),
    ssoLoginWatcherSaga(),
    getPlanDetailWatcherSaga(),
    getForgetPasswordSagaWatcherSaga(),
    getAccessCodeWatcherSaga(),
    getMedicalNeighborhoodWatcherSaga(),
    getNeighborhoodProviderWatcherSaga(),
    getUserWatcherSaga(),
    practiceReportsWatcherSaga(),
    getReferralMemberWatcherSaga(),
  ])
}
